import React from 'react';
import {
  DatabaseDownstreamOwnerIdsFilteredByTableDocument,
 DatabaseDownstreamOwnerIdsDocument } from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer,
  OwnerIdFragment,
  DatabaseDownstreamOwnerIdsFilteredByTableQueryVariables,
  DatabaseDownstreamOwnerIdsFilteredByTableQuery,
  DatabaseDownstreamOwnerIdsQueryVariables,
  DatabaseDownstreamOwnerIdsQuery
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { DatabaseDownstreamOwnersQueryGrid } from './DatabaseDownstreamOwnersQueryGrid';

export type DatabaseDownstreamOwnersPaneProps = {
  readonly title: string;
  readonly databaseVizportalId: string;
  readonly databaseId: string;
  readonly filteredTableId: string | null;
  readonly rowCount: number | null;
  readonly databaseLuid: string;
};

export class DatabaseDownstreamOwnersPane extends React.Component<DatabaseDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.databaseId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              {this.props.title}
              {this.props.rowCount != null && this.props.rowCount > 0 ?
                <>
                  <MultiSelectionControls
                    selectedKeys={selectedKeys}
                    setSelectedKeys={setSelectedKeys}
                    updateSelectionForKey={updateSelectionForKey}
                    fetchAllKeys={this.fetchAllOwnerKeys}
                  />
                  <ComposeEmailPaneButton
                    selectedUserIds={selectedKeys}
                    contentType='database'
                    contentId={this.props.databaseVizportalId}
                    contentLuid={this.props.databaseLuid}
                  />
                </>
                : null
              }
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <DatabaseDownstreamOwnersQueryGrid
                  databaseId={this.props.databaseId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredTableId={this.props.filteredTableId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredTableId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DatabaseDownstreamOwnerIdsFilteredByTableQueryVariables,
        DatabaseDownstreamOwnerIdsFilteredByTableQuery
      >({
        queryGql: DatabaseDownstreamOwnerIdsFilteredByTableDocument,
        selectConnectionListResult: (resultData) => {
          const table = resultData.tables && resultData.tables[0];
          return table.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { tableId: this.props.filteredTableId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DatabaseDownstreamOwnerIdsQueryVariables,
        DatabaseDownstreamOwnerIdsQuery
      >({
        queryGql: DatabaseDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const database = resultData.databases && resultData.databases[0];
          return database.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { databaseId: this.props.databaseId }, client);
    }
  }

}
